// Qualified Form Initialization
/* eslint-disable */
(function () {
  const RETRY_INTERVAL = 1000;
  const MAX_RETRIES = 30;
  let retries = 0;

  function initQualifiedForms() {
    if (!window.qualified) {
      if (retries < MAX_RETRIES) {
        retries++;
        setTimeout(initQualifiedForms, RETRY_INTERVAL);
      } else {
        console.error('[Qualified] Max retries reached. window.qualified not available.');
      }
      return;
    }

    const qualifiedForms = document.querySelectorAll('[data-provider="qualified"]');

    if (qualifiedForms.length === 0) {
      return;
    }

    qualifiedForms.forEach((formElement) => {
      const experienceId = formElement.getAttribute('data-qualified-experience-id');
      const targetId = formElement.getAttribute('data-qualified-target-id');

      if (!experienceId) {
        console.error('[Qualified] Missing experience ID for form', formElement);
        return;
      }

      if (!targetId) {
        console.error('[Qualified] Missing target ID for form', formElement);
        return;
      }

      const targetSelector = '#' + targetId;
      const moduleContainer = formElement.closest('[data-module="Form"]');
      const successMessageElement = moduleContainer ? moduleContainer.querySelector('[data-ref="form-success-message"]') : null;

      // Get tracking configuration from data attributes
      const lintrkConversionId = formElement.getAttribute('data-lintrk-conversion-id');
      const msuetEventName = formElement.getAttribute('data-msuet-event-name');

      try {
        window.qualified('showForm', experienceId, {
          target: targetSelector,
          version: '0',
          onSuccess: function() {
            // LinkedIn InsightTag event tracking
            if (lintrkConversionId && window.lintrk) {
              window.lintrk('track', { conversion_id: lintrkConversionId });
            }

            // Microsoft/Bing UET event tracking
            if (msuetEventName) {
              window.uetq = window.uetq || [];
              window.uetq.push('event', msuetEventName, {});
            }

            // Hide form and show success message
            if (successMessageElement) {
              formElement.setAttribute('hidden', '');
              successMessageElement.removeAttribute('hidden');

              try {
                successMessageElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
              } catch (scrollError) {
                // Scroll failed, non-critical
              }
            }
          }
        });
      } catch (error) {
        console.error('[Qualified] Error initializing form:', error);
      }
    });
  }

  initQualifiedForms();
})();
/* eslint-enable */
